export default function getTheTail(source: string, lastParamName: string) {
    const lastParamNameWithDelimiter = `${lastParamName}/`;
    const lastParamNameLength = lastParamNameWithDelimiter.length;
    const index = source.indexOf(lastParamNameWithDelimiter);
    return source.substr(index + lastParamNameLength);
}
